import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { RemittedRemittanceTransacitons } from "../../../../components/DirectDeposit/Transactions/RemittedRemittance";

export interface IRemittedRemittanceTransacitonsPage { }

export const RemittedRemittanceTransacitonsPage: FC<IRemittedRemittanceTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="CRA Due"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<RemittedRemittanceTransacitons />}
		/>
	);
};
